<template>
  <div>
    <el-table :data="tableData" stripe size="mini" style="width: 100%;margin-bottom: 20px;" border @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55">
      </el-table-column>
      <el-table-column prop="index" width="55" label="序号">
        <template slot-scope="scope">
          {{scope.$index+1+((page.pageIndex-1)*page.pageSize)}}
        </template>
      </el-table-column>
      <el-table-column prop="stu_code" label="学号" width="120"></el-table-column>
      <el-table-column prop="stu_name" label="姓名" min-width="80"></el-table-column>

      <el-table-column prop="gender" label="性别" width="80">
        <template slot-scope="scope">

          <span v-if="scope.row.gender==1">男</span>
          <span v-if="scope.row.gender==2">女</span>

          <span v-if="scope.row.gender==0">未知</span>
        </template>
      </el-table-column>
      <el-table-column prop="class_name" label="班级" width="80"></el-table-column>
      <el-table-column prop="graduate_sch_city" label="毕业地区" width="180"></el-table-column>


    </el-table>


  </div>
</template>
<script>
export default {
  name: 'Table',
  data() {
    return {}
  },
  props: {
    page: {
      type: Object,
    },
    tableData: {
      type: Array,
      default: []
    },
    from: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.$emit('handleSelectionChange', val)
    },
    handlePageChange(e) {
      this.$emit('handlePageChange', e)
    },
  }
}
</script>
